import { createReducer } from 'typesafe-actions';
import { fetchIdsDropdownDataAction, IDSDropdownActionType } from './actions';
import { IDSDropdownState } from './types';
import { get } from 'Common/utils/objectUtils';

export const defaultIdsDropdownState: IDSDropdownState = {
    image: undefined,
    isFetching: false,
    isFetched: false,
    hasFailed: false,
    didInvalidate: false,
    error: undefined,
    identifier: '',
};

export default createReducer<IDSDropdownState, IDSDropdownActionType>(defaultIdsDropdownState)
    .handleAction(fetchIdsDropdownDataAction.request, (state, action) => ({
        ...state,
        isFetching: true,
        identifier: action.payload.identifier,
    }))
    .handleAction(fetchIdsDropdownDataAction.success, (state, action) => ({
        ...state,
        image: get(action, 'payload.data.data.0.bannerImage', undefined) as IDSDropdownState['image'],
        isFetching: false,
        isFetched: true,
        hasFailed: false,
        didInvalidate: false,
        error: undefined,
    }))
    .handleAction(fetchIdsDropdownDataAction.failure, (state, action) => ({
        ...state,
        isFetching: false,
        isFetched: true,
        hasFailed: true,
        error: action.payload.error,
        didInvalidate: true,
    }));
